/**
 * Precomputed preflop all-in pot equity vs 5 random opponents (6-max) for all 169
 * starting-hand classes — i.e. win share if everyone went all-in to showdown.
 *
 * Generated ONCE offline by `OPPONENTS=5 scripts/generatePreflopEquity.mjs` using
 * the same `pokersolver` engine the app evaluates real showdowns with, so the
 * displayed numbers are self-consistent. Runtime here is a pure O(1) lookup.
 *
 * Class keys: pairs "AA".."22"; suited "AKs".."32s"; offsuit "AKo".."32o"
 * (higher rank first). Values are pot equity % (win + split share), 0–100.
 */
const RANK_ORDER: Record<string, number> = {
  '2': 2,
  '3': 3,
  '4': 4,
  '5': 5,
  '6': 6,
  '7': 7,
  '8': 8,
  '9': 9,
  T: 10,
  J: 11,
  Q: 12,
  K: 13,
  A: 14
}

export const PREFLOP_EQUITY: Record<string, number> = {
  'AA': 49.2,
  'KK': 42.9,
  'QQ': 37.8,
  'JJ': 33.8,
  'TT': 29.9,
  '99': 26.6,
  '88': 23.9,
  '77': 21.9,
  '66': 20.1,
  '55': 18.5,
  '44': 17.4,
  '33': 16.1,
  '22': 15.6,
  'AKs': 30.9,
  'AQs': 29.5,
  'AJs': 27.9,
  'ATs': 26.7,
  'A9s': 24.2,
  'A8s': 23.2,
  'A7s': 22.5,
  'A6s': 21.8,
  'A5s': 21.8,
  'A4s': 21.6,
  'A3s': 21.2,
  'A2s': 20.5,
  'KQs': 28.3,
  'KJs': 27.1,
  'KTs': 25.8,
  'K9s': 23.5,
  'K8s': 21.5,
  'K7s': 20.8,
  'K6s': 20.0,
  'K5s': 19.5,
  'K4s': 19.2,
  'K3s': 18.7,
  'K2s': 18.3,
  'QJs': 26.3,
  'QTs': 25.2,
  'Q9s': 22.4,
  'Q8s': 20.9,
  'Q7s': 19.1,
  'Q6s': 18.5,
  'Q5s': 17.8,
  'Q4s': 17.5,
  'Q3s': 17.1,
  'Q2s': 16.6,
  'JTs': 24.8,
  'J9s': 22.3,
  'J8s': 20.4,
  'J7s': 18.9,
  'J6s': 17.4,
  'J5s': 16.8,
  'J4s': 16.4,
  'J3s': 15.9,
  'J2s': 15.8,
  'T9s': 22.3,
  'T8s': 20.6,
  'T7s': 19.0,
  'T6s': 17.5,
  'T5s': 16.0,
  'T4s': 15.5,
  'T3s': 15.2,
  'T2s': 15.1,
  '98s': 20.3,
  '97s': 18.9,
  '96s': 17.6,
  '95s': 16.0,
  '94s': 14.5,
  '93s': 14.2,
  '92s': 14.0,
  '87s': 18.8,
  '86s': 17.3,
  '85s': 16.3,
  '84s': 14.8,
  '83s': 13.7,
  '82s': 13.4,
  '76s': 17.9,
  '75s': 16.7,
  '74s': 15.4,
  '73s': 14.2,
  '72s': 12.8,
  '65s': 17.1,
  '64s': 15.9,
  '63s': 14.6,
  '62s': 13.4,
  '54s': 16.6,
  '53s': 15.4,
  '52s': 14.1,
  '43s': 14.8,
  '42s': 13.7,
  '32s': 13.2,
  'AKo': 28.0,
  'AQo': 25.7,
  'AJo': 24.5,
  'ATo': 23.2,
  'A9o': 20.2,
  'A8o': 19.2,
  'A7o': 18.1,
  'A6o': 17.8,
  'A5o': 17.8,
  'A4o': 17.5,
  'A3o': 17.0,
  'A2o': 16.3,
  'KQo': 25.1,
  'KJo': 23.4,
  'KTo': 22.2,
  'K9o': 19.5,
  'K8o': 17.3,
  'K7o': 16.6,
  'K6o': 15.9,
  'K5o': 15.3,
  'K4o': 14.7,
  'K3o': 14.4,
  'K2o': 13.8,
  'QJo': 22.9,
  'QTo': 21.7,
  'Q9o': 19.1,
  'Q8o': 16.7,
  'Q7o': 14.9,
  'Q6o': 14.4,
  'Q5o': 13.7,
  'Q4o': 13.4,
  'Q3o': 12.7,
  'Q2o': 12.5,
  'JTo': 21.5,
  'J9o': 18.6,
  'J8o': 16.8,
  'J7o': 14.9,
  'J6o': 13.3,
  'J5o': 12.9,
  'J4o': 12.2,
  'J3o': 12.0,
  'J2o': 11.4,
  'T9o': 19.0,
  'T8o': 16.8,
  'T7o': 15.2,
  'T6o': 13.4,
  'T5o': 11.8,
  'T4o': 11.5,
  'T3o': 10.9,
  'T2o': 10.6,
  '98o': 16.8,
  '97o': 15.0,
  '96o': 13.3,
  '95o': 12.0,
  '94o': 10.4,
  '93o': 10.2,
  '92o': 9.8,
  '87o': 15.3,
  '86o': 13.8,
  '85o': 12.2,
  '84o': 10.8,
  '83o': 9.6,
  '82o': 9.0,
  '76o': 14.1,
  '75o': 12.9,
  '74o': 11.4,
  '73o': 9.9,
  '72o': 8.6,
  '65o': 13.2,
  '64o': 12.0,
  '63o': 10.5,
  '62o': 9.2,
  '54o': 12.6,
  '53o': 11.5,
  '52o': 10.1,
  '43o': 10.8,
  '42o': 9.6,
  '32o': 9.0
}

/**
 * Canonicalize a concrete 2-card hand into its 169-class key.
 * @example toPreflopClass(['As', 'Ks']) // 'AKs'
 * @example toPreflopClass(['Kd', 'As']) // 'AKo'
 * @example toPreflopClass(['7h', '7c']) // '77'
 */
export function toPreflopClass(cards: string[]): string {
  const v1 = cards[0][0]
  const v2 = cards[1][0]
  const s1 = cards[0].slice(-1)
  const s2 = cards[1].slice(-1)
  if (v1 === v2) return `${v1}${v2}`
  const firstHigher = (RANK_ORDER[v1] ?? 0) >= (RANK_ORDER[v2] ?? 0)
  const hi = firstHigher ? v1 : v2
  const lo = firstHigher ? v2 : v1
  return `${hi}${lo}${s1 === s2 ? 's' : 'o'}`
}

/**
 * All-in pot equity vs 5 opponents (6-max) for a concrete 2-card hand (O(1) lookup).
 */
export function getPreflopEquity(cards: string[]): number {
  return PREFLOP_EQUITY[toPreflopClass(cards)] ?? 0
}

export type StrengthTier = 'premium' | 'strong' | 'marginal' | 'muck'

/**
 * Map a 6-max all-in equity to a teaching strength tier. Bands are tuned to the
 * compressed multi-way scale (deck spans ~9–49%, median ~17%); they describe hand
 * strength, not a situational play/fold.
 */
export function strengthTier(equity: number): StrengthTier {
  if (equity >= 28) return 'premium'
  if (equity >= 23) return 'strong'
  if (equity >= 17) return 'marginal'
  return 'muck'
}

const MIN_EQUITY = Math.min(...Object.values(PREFLOP_EQUITY))
const MAX_EQUITY = Math.max(...Object.values(PREFLOP_EQUITY))

/**
 * Map a 6-max all-in equity to a 0–100 teaching "hand strength" score. Bucket-aligned
 * to the same thresholds as `strengthTier`: each tier occupies an even quarter of the
 * scale (muck 0–25, marginal 25–50, strong 50–75, premium 75–100), interpolated
 * linearly within its band and anchored at the table extremes so the best hand reads
 * ~100 and the worst ~0. The number therefore never contradicts the tier color. This
 * is a presentation scale for recognizing relative hole-card strength — not an equity
 * or a play/fold signal.
 */
export function handStrengthScore(equity: number): number {
  const e = Math.max(MIN_EQUITY, Math.min(MAX_EQUITY, equity))
  const band = (eLo: number, eHi: number, sLo: number, sHi: number): number =>
    Math.round(sLo + ((e - eLo) / (eHi - eLo)) * (sHi - sLo))
  if (e >= 28) return band(28, MAX_EQUITY, 75, 100)
  if (e >= 23) return band(23, 28, 50, 75)
  if (e >= 17) return band(17, 23, 25, 50)
  return band(MIN_EQUITY, 17, 0, 25)
}
